module.exports = __webpack_public_path__ + "img/item_1.1b087a2a.png";